import React, {PropsWithChildren} from 'react'

const DefaultLayout: React.FC<PropsWithChildren> = ({children}) => {
  return children
}

export default DefaultLayout
